import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import StickyCall from "../components/StickyCall";
import { Phone, Eye } from "lucide-react";
import { site } from "../mock";
import { CallbackButton } from "../components/PageBlocks";

export default function Voyance() {
  return (
    <div>
      <Header />
      <StickyCall />
      <section className="hero-radial py-14 md:py-20">
        <div className="container-narrow grid md:grid-cols-2 gap-8 md:gap-10 items-center">
          <div className="order-1 md:order-none">
            <p className="text-[11px] uppercase tracking-[0.3em] text-gold-deep mb-3">Voyance & Médiumnité</p>
            <h1 className="font-display text-4xl md:text-5xl gold-gradient-text mb-4">Voir clair, décider juste</h1>
            <div className="gold-divider my-5 max-w-[220px]" />
            <p className="text-gold-soft/95 leading-relaxed mb-4">
              Vous doutez d'un amour, d'une décision, d'une personne ? Maître Diamma lit votre chemin de vie à travers ses <span className="text-gold">oracles africains</span> hérités de ses maîtres. Ses réponses sont directes, précises et pleines de sagesse.
            </p>
            <p className="text-gold-soft/95 leading-relaxed mb-6">
              Consultez à son cabinet du centre d'Orléans, chez vous à Olivet, Fleury-les-Aubrais, Saran, Montargis ou partout dans le Loiret, ou simplement par téléphone. Vous ressortirez avec des repères solides et la paix intérieure.
            </p>
            <div className="flex flex-wrap gap-3">
              <CallbackButton id="voyance-hero" context="Voyance" />
              <a href={`tel:${site.phoneRaw}`} className="btn-gold inline-flex rounded-md px-6 py-3 items-center gap-2">
                <Phone className="w-4 h-4" /> Réserver ma consultation
              </a>
            </div>
          </div>
          <div className="relative rounded-xl overflow-hidden gold-border-strong order-2 md:order-none">
            <img src="/images/diamma-ecriture.jpg" alt="Maître Diamma, voyant médium à Orléans" className="w-full h-[300px] md:h-[440px] object-cover object-top" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
          </div>
        </div>
      </section>
      <section className="py-14 md:py-16 bg-charcoal">
        <div className="container-narrow grid md:grid-cols-3 gap-6">
          {[
            { t: "Amour & Couple", d: "Comprendre les vraies intentions de l'autre, anticiper l'évolution de la relation, décider en paix." },
            { t: "Travail & Argent", d: "Éclairer un choix professionnel, sécuriser un projet, attirer les bonnes opportunités et la prospérité." },
            { t: "Santé & Énergies", d: "Détecter les blocages énergétiques, les influences négatives et poser les premières pierres de la guérison." }
          ].map((c) => (
            <div key={c.t} className="card-onyx rounded-xl p-6">
              <Eye className="w-6 h-6 text-gold mb-3" />
              <h3 className="font-display text-lg text-gold mb-2">{c.t}</h3>
              <p className="text-sm text-gold-soft/95 leading-relaxed">{c.d}</p>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
